import { useState } from "react";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { FiShield, FiCheck } from "react-icons/fi";
import "./AntiSpamModal.css";

const AntiSpamModal = ({ onClose }) => {
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { sendRequest } = useHttp();

  const handleSubmit = () => {
    if (!agreed) return;
    setSubmitting(true);

    sendRequest(
      { url: endPoints.acceptTos, method: "GET" },
      (response) => {
        if (response.status === 200) {
          onClose();
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <div className="asm-overlay">
      <div className="asm-backdrop" />
      <div className="asm-container">
        <div className="asm-modal">
          <div className="asm-icon-wrap">
            <FiShield size={28} />
          </div>

          <h3 className="asm-title">Terms of Service</h3>
          <p className="asm-subtitle">
            Please review and accept our terms before continuing
          </p>

          <div className="asm-content">
            <p>
              By checking the box below, you acknowledge and agree that you will
              use the SiteBuilder platform in compliance with all applicable
              local, national, and international laws.
            </p>
            <p>
              The website creation tools provided must not be used for any
              illegal, unethical, or harmful activities. Any violation of this
              agreement may result in suspension or termination of your account.
            </p>
            <p>
              As the user, you are solely responsible for all websites and
              content created using SiteBuilder. You must not violate any
              copyright, trademark, or third-party terms and conditions.
            </p>
          </div>

          <label className="asm-checkbox-label">
            <input
              type="checkbox"
              checked={agreed}
              onChange={() => setAgreed(!agreed)}
              className="asm-checkbox-input"
              id="asm-agree"
            />
            <div className={`asm-checkbox ${agreed ? "asm-checkbox-checked" : ""}`}>
              {agreed && <FiCheck size={14} />}
            </div>
            <span>I agree to the terms and conditions</span>
          </label>

          <button
            className="asm-submit-btn"
            disabled={!agreed || submitting}
            onClick={handleSubmit}
          >
            {submitting ? "Submitting..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AntiSpamModal;
